import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import {
  getCustomers,
  createCustomers,
  updateCustomers,
  deleteCustomers,
} from '../api/customersAPI';

const CustomersLayer = () => {
  const userProfile = useUserProfile();
  const [customerList, setCustomerList] = useState([]);
  const [newCustomer, setNewCustomer] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const fetchCustomers = async () => {
    try {
      const data = await getCustomers();
      setCustomerList(data);
    } catch (err) {
      console.error('Error fetching customers:', err);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    if (dtRef.current) dtRef.current.destroy();
    if (customerList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({ pageLength: 25, dom: 'rtip' });
    }
    return () => dtRef.current?.destroy(true);
  }, [customerList]);

  useEffect(() => {
    dtRef.current?.search(searchTerm).draw();
  }, [searchTerm]);

  const validateForm = () => {
    const newErrors = {};
    if (!newCustomer.name?.trim()) newErrors.name = 'Name is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCustomer(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    const payload = {};
    for (const key in newCustomer) {
      if (newCustomer[key] !== null && typeof newCustomer[key] !== 'object') {
        payload[key] = newCustomer[key];
      }
    }
    editingId ? await updateCustomers(editingId, payload) : await createCustomers(payload);
    setShowModal(false);
    setEditingId(null);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    setNewCustomer({});
    await fetchCustomers();
  };

  const handleEdit = (item) => {
    setNewCustomer(item);
    setEditingId(item.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete customer?')) return;
    await deleteCustomers(id);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    await fetchCustomers();
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between p-3">
        <input type="text" className="form-control w-auto" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        {userProfile?.privileges?.includes('customers:create') && (
          <button className="btn btn-primary btn-sm d-flex align-items-center gap-2" onClick={() => { setNewCustomer({}); setEditingId(null); setShowModal(true); }}>
            <Icon icon="ic:baseline-plus" className="icon text-xl" /> Add Customer
          </button>
        )}
      </div>

      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table ref={tableRef} className="table bordered-table mb-0">
            <thead><tr><th>Name</th><th>CRM ID</th><th>Website</th><th>Actions</th></tr></thead>
            <tbody>
              {customerList.map(item => (
                <tr key={item.id}>
                  <td><strong>{item.name}</strong></td>
                  <td>{item.crmId}</td>
                  <td>{item.website}</td>
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('customers:update') && (
                        <button className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center" onClick={() => handleEdit(item)}>
                          <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                        </button>
                      )}
                      {userProfile?.privileges?.includes('customers:delete') && (
                        <button className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center" onClick={() => handleDelete(item.id)}>
                          <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg"><div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">{editingId ? 'Edit Customer' : 'New Customer'}</h5><button className="btn-close" onClick={() => setShowModal(false)} /></div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Name *</label>
                <input className={`form-control ${errors.name ? 'is-invalid' : ''}`} name="name" value={newCustomer.name || ''} onChange={handleInputChange} />
                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">CRM ID</label>
                <input className="form-control" name="crmId" value={newCustomer.crmId || ''} onChange={handleInputChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">Website</label>
                <input className="form-control" name="website" value={newCustomer.website || ''} onChange={handleInputChange} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
            </div>
          </div></div>
        </div>
      )}
    </div>
  );
};

export default CustomersLayer;
